<template>
    <component v-model="user" :is="steps[stepIndex]" @next="stepIndex++"/>
</template>

<script>
import StepType from "./step-type.vue";
import StepTerms from "./step-terms.vue";
import StepForm from "./step-form.vue";
import StepComplete from "./step-complete.vue";

export default {
    components: {
        StepType,
        StepTerms,
        StepForm,
        StepComplete
    },
    data(){
        return {
            stepIndex: 1,
            steps: ["step-type", "step-terms", "step-form", "step-complete"],

            user: {
                _terms: [],

                name: null,
                type: "member",
                username: null,
                password: null,
                password2: null,
                
                phone: null,
                phone1: null,
                phone2: null,
                phone3: null,

                email: null,
                email1: null,
                email2: null,
                email3: null,

                postcode: null,
                address1: null,
                address2: null,
                
                smsEnabled: true,
                emailEnabled: true,
            }
        }
    },
}
</script>